import * as React from 'react';

import ProjectTypeSelector from './ProjectTypeSelector';
import { ProjectTypeRenderer } from '../../models/ProjectType';
import DancingManDesktop from './DancingManDesktop';

const Home = () => (
  <>
    <DancingManDesktop />
    <ProjectTypeRenderer render={ProjectTypeSelector} />
  </>
);

export default Home;



// WEBPACK FOOTER //
// ./src/scenes/Home/index.tsx